"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {};
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _modal = _interopRequireWildcard(require("antd/lib/modal"));
Object.keys(_modal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _modal[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _modal[key];
    }
  });
});
var _hoistNonReactStatics = _interopRequireDefault(require("hoist-non-react-statics"));
var _withLocaleProvider = _interopRequireDefault(require("../_utils/withLocaleProvider"));
var _Modal = _interopRequireDefault(require("./Modal"));
var _QuestionIcon = _interopRequireDefault(require("../_assets/QuestionIcon"));
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var InternalModal = (0, _withLocaleProvider["default"])(_Modal["default"]);
var Modal = InternalModal;
(0, _hoistNonReactStatics["default"])(Modal, _modal["default"]);
Modal.info = function infoFn(props) {
  return _modal["default"].info((0, _extends2["default"])({
    centered: true,
    width: 420
  }, props));
};
Modal.success = function successFn(props) {
  return _modal["default"].success((0, _extends2["default"])({
    centered: true,
    width: 420
  }, props));
};
Modal.error = function errorFn(props) {
  return _modal["default"].error((0, _extends2["default"])({
    centered: true,
    width: 420
  }, props));
};
Modal.warn = function warnFn(props) {
  return _modal["default"].warn((0, _extends2["default"])({
    centered: true,
    width: 420
  }, props));
};
Modal.warning = Modal.warn;
Modal.confirm = function confirmFn(props) {
  return _modal["default"].confirm((0, _extends2["default"])({
    icon: /*#__PURE__*/_react["default"].createElement("span", {
      role: "img",
      className: "anticon"
    }, /*#__PURE__*/_react["default"].createElement(_QuestionIcon["default"], null)),
    centered: true,
    width: 420
  }, props));
};
var _default = exports["default"] = Modal;